import StickyPageHeader from '../components/common/StickyPageHeader';
import DefaultModeList from '../components/lists/DefaultModeList';
import { useDefaultModes } from '../hooks/apiHooks';
import Layout from '../layout';

const AdminModesPage = ({ routes }) => {
  const { defaultModes } = useDefaultModes();

  return (
    <>
      <StickyPageHeader isAdmin title="Settings / Modes of Transport" />
      <Layout
        showCarriersNavigation
        disableLoading={false}
        menuIndex={0}
        routes={routes}
      >
        <DefaultModeList id="modes" modes={defaultModes} />
      </Layout>
    </>
  );
};

export default AdminModesPage;
